import { PanelRightClose } from "lucide-react";

import { Column, Row, Text } from "@/components";
import { Button } from "@/components/ui/button";
import { useUserSheet } from "@/components/user-sheet/userSheetContext";

import { useIsMobile } from "@/hooks/use-mobile";

// "Communications" title row with the hover-revealed collapse button, shared by
// desktop rail panels. Mobile collapses into the Messages/Email tab row instead.
export const CommsPanelCollapseHeader = () => {
  /* Context */
  const { closeCommunications } = useUserSheet();
  const isMobile = useIsMobile();

  /* Render */
  const render = () => {
    if (isMobile) return null;

    return (
      <Column className="relative z-10 min-w-0 shrink-0 gap-2 bg-transparent">
        <Row className="group/comms-collapse min-w-0 shrink-0 items-center">
          <div className="grid max-w-0 grid-cols-[0fr] opacity-0 transition-[max-width,opacity,grid-template-columns] duration-150 group-focus-within/comms-collapse:max-w-8 group-focus-within/comms-collapse:grid-cols-[1fr] group-focus-within/comms-collapse:opacity-100 group-hover/comms-collapse:max-w-8 group-hover/comms-collapse:grid-cols-[1fr] group-hover/comms-collapse:opacity-100">
            <div className="min-w-0 overflow-hidden">
              <Button
                className="h-8 w-8 shrink-0 bg-transparent text-slate-400 hover:bg-transparent hover:text-slate-600 focus-visible:opacity-100"
                onClick={closeCommunications}
                size="icon"
                title="Collapse communications"
                type="button"
                variant="ghost"
              >
                <PanelRightClose className="h-4 w-4" />
              </Button>
            </div>
          </div>
          <Button
            className="h-auto w-auto shrink-0 cursor-pointer bg-transparent p-0 hover:bg-transparent"
            onClick={closeCommunications}
            title="Collapse communications"
            type="button"
            variant="ghost"
          >
            <Text className="text-base font-medium text-slate-900">
              Communications
            </Text>
          </Button>
        </Row>
      </Column>
    );
  };

  return render();
};
